// src/components/WhatsAppFloatButton.js
import React from 'react';
import './WhatsAppFloatButton.css';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppFloatButton = ({ link = 'https://whatsapp.com/channel/0029Va9jFohEVccPnwkPAJ46'}) => {
  const whatsappLink = link;

  return (
    <a
      href={whatsappLink}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Join us on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};

export default WhatsAppFloatButton;
